import { toast as reactToast } from "react-toastify";
import { normalizeToastContent } from "./friendlyMessage";

const show = (method, type) => (content, options) => {
  const handler = reactToast[method] || reactToast[type] || reactToast;
  const message = normalizeToastContent(content, type);
  return options === undefined ? handler(message) : handler(message, options);
};

export const toast = Object.assign(
  (content, options) => options === undefined
    ? reactToast(normalizeToastContent(content, "info"))
    : reactToast(normalizeToastContent(content, "info"), options),
  reactToast,
  {
    success: show("success", "success"),
    error: show("error", "error"),
    info: show("info", "info"),
    warn: show("warn", "warning"),
    warning: show("warn", "warning"),
  }
);

